import { ITranslations } from 'types/common';
import en from 'translations/en/productCategoryKeywordsForm.json';
import pl from 'translations/pl/productCategoryKeywordsForm.json';
import sl from 'translations/sl/productCategoryKeywordsForm.json';
import { ProductCategoryKeywordsFormTransFields } from './types';

export const productCategoryKeywordsFormTranslations: ITranslations<ProductCategoryKeywordsFormTransFields> = {
  name: 'productCategoryKeywordsForm',
  en,
  pl,
  sl,
};
